import * as SwitchPrimitive from '@radix-ui/react-switch'
import PropTypes from 'prop-types'

// Utils
import { cn } from '@/utils/helpers'

function Switch({ className, ...props }) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        // Off-state track uses muted-foreground rather than --input: --input is
        // tuned for thin control borders (see index.css) and is nearly
        // invisible as a fill on a white surface.
        'peer data-[state=checked]:bg-primary data-[state=unchecked]:bg-muted-foreground/45 focus-visible:border-ring focus-visible:ring-ring/50 dark:data-[state=unchecked]:bg-input/80 inline-flex h-[1.15rem] w-8 shrink-0 items-center rounded-full border border-transparent shadow-xs transition-all outline-none focus-visible:ring-[3px] disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          'bg-background dark:data-[state=unchecked]:bg-foreground dark:data-[state=checked]:bg-primary-foreground pointer-events-none block size-4 rounded-full shadow-sm ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0',
        )}
      />
    </SwitchPrimitive.Root>
  )
}

Switch.propTypes = {
  className: PropTypes.string,
}

export { Switch }
